import OnboardingUsers from '../../components/onboarding/OnboardingUsers';
import { compose, lifecycle, withState, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import _ from 'lodash';
import { store } from 'store/createStore';

import { checkPermission } from 'utils/credentials';
import { ROLES } from '../../../../../consts';
import API from '../../../../../utils/api';

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = state => {
  return {
    roles: _.get(state, 'auth.currentGroup.myRoles', 'default'),
  };
};

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withState('selectedTab', 'updateSelectedTab', 0),
  withHandlers({
    getOnboardingUsers: props => (filter, per_page, page) => {
      const { currentGroup } = store.getState().auth;
      const query = {
        group: currentGroup._id,
        ...filter,
      };

      return API.getOnboardingUsers({
        ...query,
        per_page,
        page,
      }).then(onboardingData => {
        return onboardingData;
      });
    },
  }),
  lifecycle({
    async componentDidUpdate(prevProps) {
      checkPermission(this, ROLES.ANALYTICS);
    },
    componentDidMount() {},
  })
);

export default enhance(OnboardingUsers);
